'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as SliderPrimitive from '@radix-ui/react-slider';
import * as React from 'react';
import { MinusLine, PlusLine } from '@zealy/icons';
import { cn } from '../../utils/cn';
import { styles } from './Slider.styles';
const Slider = React.forwardRef(({ className, size, variant, bg = 'var(--color-bg-primary)', ...props }, ref) => {
    const style = React.useMemo(() => ({
        '--color-bg': bg,
    }), [bg]);
    return (_jsxs("div", { className: styles.root({ size, variant }), style: style, children: [_jsx(MinusLine, { className: styles.icon({ size }) }), _jsxs(SliderPrimitive.Root, { ref: ref, className: cn('relative flex w-full touch-none select-none items-center', className), ...props, children: [_jsx(SliderPrimitive.Track, { className: styles.track({ size }), children: _jsx(SliderPrimitive.Range, { className: styles.range({ size, variant }) }) }), _jsx(SliderPrimitive.Thumb, { className: styles.thumb({ size }) })] }), _jsx(PlusLine, { className: styles.icon({ size }) })] }));
});
Slider.displayName = SliderPrimitive.Root.displayName;
export { Slider };
